import axios from 'lib/axios';
import {
  removeAuthCookie,
  removeUserInStorage,
} from 'lib/Storage';

const login = async (username, password) => {
  const { data } = await axios.post('/signin', username, password);
  return data;
};

const logout = () => {
  removeAuthCookie();
  removeUserInStorage();
  // eslint-disable-next-line no-restricted-globals
  location.reload();
};

export { login, logout };
